import { fetcher } from '@packages/cms-components';
import type { DrupalApiPromotion } from '@packages/cms-components/interfaces';
import config from '@packages/config';
import { cached } from '@packages/shared';
import type { Promotion } from '../types';
import { mapDrupalPromotionToPromotion } from './mapDataToPromotion';

// fetch a promotion by code
export const fetchPromoData = async (
  code: { cart: string; texts: string },
  locale: string = 'de',
  callOwnApi?: boolean,
): Promise<Promotion | undefined> => {
  // fetch from bucket only - the promotions are stored here after they are saved in drupal
  const fetchUrl = callOwnApi
    ? `/api/promotions/promotion/${code.texts}/?locale=${locale}`
    : config.promotionBanner.apiEndpoints.bucketPromotion
        .replace('<language>', locale.substring(0, 2))
        .replace('<code>', code.texts);
  return cached(
    [fetchUrl, code.cart].join(''),
    () =>
      fetcher<DrupalApiPromotion | Promotion>(fetchUrl).then((fetchedData) => {
        if ('data' in fetchedData) {
          return fetchedData && mapDrupalPromotionToPromotion(fetchedData.data[0], code.cart);
        }
        return fetchedData;
      }),
    5 * 60 * 1000,
  )();
};
